import type { BadgeVariant } from '@/components/common/Badge';

/**
 * Display when incomm_demo.card_status is null/empty: no InComm card lifecycle status
 * has been recorded yet (typically not yet sent / not yet reflected from InComm).
 */
export const INCOMM_CARD_STATUS_UNSET_LABEL = 'Not sent to InComm yet';

/** Human-readable label for table cells and badges (null/empty → unset explanation). */
export function formatCardStatusLabel(status: string | null | undefined): string {
  if (status == null || status.trim() === '') {
    return INCOMM_CARD_STATUS_UNSET_LABEL;
  }
  return status;
}

/** Maps incomm_demo.card_status (CardStatus enum strings) to dashboard Badge variants. */
export function cardStatusBadgeVariant(status: string | null): BadgeVariant {
  if (status == null || status === '') return 'info';
  const s = status.toLowerCase();
  if (s === 'active') return 'success';
  if (s === 'pending' || s === 'activating' || s === 'processing' || s === 'funding' || s === 'new') {
    return 'warning';
  }
  if (s === 'error') return 'danger';
  if (s === 'shipped') return 'info';
  if (s === 'not_ordered') return 'default';
  if (s.startsWith('closed') || s === 'on_hold' || s === 'on_hold_by_system' || s === 'lost_stolen_pending') {
    return 'default';
  }
  return 'default';
}

/** All CardStatus values from rewards-service app/schemas/v1/card_status.py (for filter dropdowns). */
export const INCOMM_CARD_STATUS_FILTER_OPTIONS: readonly string[] = [
  '',
  'not_ordered',
  'processing',
  'error',
  'shipped',
  'new',
  'funding',
  'activating',
  'pending',
  'active',
  'on_hold',
  'on_hold_by_system',
  'lost_stolen_pending',
  'closed_replaced',
  'closed_ineligible',
  'closed',
  'closed_expired',
  'closed_redeemed',
] as const;
